import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShopPage from "../pages/shop/page";
import ProductDetailPage from "../pages/shop/detail/page";
import ContactPage from "../pages/contact/page";
import FAQPage from "../pages/faq/page";
import InstallationGuidesPage from "../pages/guides/page";
import WarrantyPage from "../pages/warranty/page";
import AboutPage from "../pages/about/page";
import ComparePage from "../pages/compare/page";
import SystemsComparisonPage from "../pages/systems-comparison/page";
import MAPPolicyPage from "../pages/map-policy/page";
import OrderTrackingPage from "../pages/order-tracking/page";
import AuthorizedBrandsPage from "../pages/brands/page";
import EcoFlowPage from "../pages/ecoflow/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/shop/:id", element: <ProductDetailPage /> },
  { path: "/compare", element: <ComparePage /> },
  { path: "/compare-backup-power-systems", element: <SystemsComparisonPage /> },
  { path: "/map-policy", element: <MAPPolicyPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/installation-guides", element: <InstallationGuidesPage /> },
  { path: "/warranty", element: <WarrantyPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/authorized-brands", element: <AuthorizedBrandsPage /> },
  { path: "/order-tracking", element: <OrderTrackingPage /> },
  { path: "/ecoflow", element: <EcoFlowPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
